export default __webpack_public_path__ + "static/media/line_info.bea4ed3e.png";